import { settlementBankAccountInfoType } from '/#/obboarding';
import { BasicPageParams, BasicPageResult } from '/@/api/model/baseModel';
import { SettlementAccountStatusEnum } from '/@/enums/exchangeServiceEnum';

export enum TradingAccountLevelEnum {
  ALL = -1, // 全部
  MAIN = 0, // 父账户
  SUBORDINATE = 1, // 子账户
}

export enum TradingAccountStatusEnum {
  NORMAL = 0, // 正常
  CLOSED = 1, // 注销
  CREATING = 2, // 开通中
  CREATING_FAILED = 3, // 开通失败
}
/**
 * @description: Request list interface parameters
 */
export interface TradingAccountSearchParams extends BasicPageParams {
  tradingAccountLevel?: TradingAccountLevelEnum; // 账户级别
  status?: TradingAccountStatusEnum; // 账户状态
  accountCode?: string; // 交易账户编号/资金账号编号
}

export type CurrencyType = 'RMB' | 'MOP' | 'HKD' | 'USD' | 'CNY';
export interface WalletType {
  currentBalance?: number; // 当前余额
  availableBalance?: number; // 可用余额
  accruedBalance?: number; // 计提余额(欠费的记录在这里)
  frozenBalance?: number; // 冻结余额
  yesterdayAcfTotal?: number;
  allocation?: number; //分配金额
  updateTime?: Date;
  currency: CurrencyType;
}
export interface TradingAccountListItem extends WalletType {
  tradingAccountCode: string; // 交易账户编号
  memberId: number; // 会员id
  certificateAccountCode: string; // 登记账户编号
  fundAccountCode: string; // 资金账号编号
  tradingAccountLevel: TradingAccountLevelEnum; // 账户级别
  parentTradingAccountId?: number | null; // 父交易账号id，若等于null则自己就为父交易账号
  status: TradingAccountStatusEnum; // 账户状态
  associatedSubject: string; // 关联主体
  balance?: number; // 账户余额
  createTime: string; // 创建时间
  wallets: WalletType[];
  currentBalance?: number; // 当前余额
  availableBalance?: number; // 可用余额
  accruedBalance?: number; // 计提余额(欠费的记录在这里)
  frozenBalance?: number; // 冻结余额
  yesterdayAcfTotal?: number;
  allocation?: number; //分配金额
  updateTime?: Date;
  tradingAccountName?: string; // clint name
}

/**
 * @description: Request list return value
 */
export type TradingAccountSearchResultModel = BasicPageResult<TradingAccountListItem>;

export type TradingAccountAllResultModel = BasicPageResult<
  Exclude<
    TradingAccountListItem,
    'currentBalance' | 'availableBalance' | 'accruedBalance' | 'frozenBalance	'
  >
>;

export type AccountRequestModel = {
  tradingAccountCode: string;
};
export type AccountResultModel = WalletType[];

export type toFundTransferAccount = {
  toTradingAccountCode: string;
  amount: number;
};

export type fundTransferRequestModel = {
  fromTradingAccountCode: string;
  toAccountInfoList: toFundTransferAccount[];
  associatedSubject?: string;
  currency: CurrencyType;
};

export type SettlementBankSearchResultModel = settlementBankAccountInfoType[];

export interface AddSettlementBankRequestModel {
  memberId?: number;
  bankName?: string;
  bankAccountName?: string;
  bankAccountNo?: string;
  bankAddress?: string;
  bankSwiftCode?: string;
  dataStatus?: SettlementAccountStatusEnum;
}

export interface IAccountOverviewItem {
  currency: CurrencyType;
  availableAmount: number; // 可提资金
  freezeAmount: number; // 冻结资金
  shareAmountLtd: number; // 累计分配资金
  shareAmountHoldLtd: number; // 当前持仓累计分配资金
  shareAmountHold0d: number; // 当日持仓分配资金
  investedAmount: number; // 已投金额
  yesterdayShare: number; // 昨日分配
}

export interface IProductOverviewItem {
  productType: string;
  storeCnt: number;
  brandCnt: number;
  droCnt: number;
  drpCnt: number;
}
export interface IAccountOverviewResult {
  mop: IAccountOverviewItem;
  rmb: IAccountOverviewItem;
  dataDate: string;
  currencys: string[];
  instrumentTypes: string[];
  storeCnt: number;
  brandCnt: number;
  droCnt: number;
  drpCnt: number;
  types: {
    [key: string]: string[];
  };
}
